<template>
    <div class="page">
        <p>
            {{ date }}
        </p>
        <p>
            {{ userStore.user.firstname }}
            {{ userStore.user.lastname }}
            <br />{{ userStore.user.address }}
            <br />{{ userStore.user.city }},
            {{ userStore.user.state }}
            {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
        </p>
        <p>To Whom It May Concern:</p>

        <p class="letter-content">
            While checking my most recent credit report, I noticed unauthorized, false and fraudulent reporting inquiries made by the following companies:
        </p>
        <h3>
           <strong>Inquiries in Dispute:</strong>
        </h3>
        <p v-for="(inquiry, iteration) in reportStore.getInquiries(1, creditBureau.name)">
            {{ iteration+1 }}. {{ inquiry.creditor_name }},
            <br />
            <strong>
                Delete this Inquiry for fraudulent reporting becuase 
                <template v-if="inquiry.reason">
                    {{ inquiry.reason }}
                </template> The Inquiry was reported on {{ inquiry.date_of_inquiry }}
            </strong>
        </p>

        <p class="letter-content">
            I did not authorize anyone employed by these companies to make any inquiry and/or view my credit report. In addition, I did not give you; {{ creditBureau.name }}, written permission or my consent to furnish this information onto my credit report or consumer credit file.
        </p>
        <p class="letter-content">
            Please note that you have 30 days to produce the requested contract and to complete this investigation, as per the Fair Credit Reporting Act section 611.
        </p>
        <p>
            Enclosed are copies of ID and proof of mailing address.
        </p>
        <p style="page-break-after: always;">
            Thank you for your time, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>